/* eslint-disable no-underscore-dangle */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isBrowser, isMobileOnly, isTablet } from 'react-device-detect';
import getBrowser from './getBrowser';
const INTERNAL_CAMPAIGN_ID_PARAM = 'intcmp';
const EXTERNAL_CAMPAIGN_ID_PARAM = 'sitecode';
/**
 * window may be undefined in Next.js apps
 */
if (typeof window !== 'undefined') {
    if (!(window === null || window === void 0 ? void 0 : window._SFDDL)) {
        window._SFDDL = {
            pageInfo: {
                Country_Language: '',
                SiteIdentifier: '',
                Device: '',
                PNL: '',
                ClientName: '',
                CustomerType: '',
                Product: '',
                PageKind: '',
                pageName: '',
                PageFunction: '',
                PageSubFunction: '',
                previouslyVisited: '',
                Token: '',
                Message: '',
                MessageType: '',
                numberOfAccounts: '',
                ErrorMessage: '',
                RelyingParty: ''
            }
        };
    }
    // v2 is a work in progress
    if (!(window === null || window === void 0 ? void 0 : window._SFDDL_V2)) {
        window._SFDDL_V2 = {
            metadata_generic: [],
            metadata_web: [],
            metadata_campaigns: [],
            metadata_digital_servicing: [],
            event: []
        };
    }
}
const device = (isBrowser && 'desk') ||
    (isMobileOnly && 'mobile') ||
    (isTablet && 'tab') ||
    '';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const analyticsConfig = Object.freeze({
    pageEvents: {},
    defaults: {
        Country_Language: '',
        SiteIdentifier: '',
        Device: device,
        PNL: '',
        ClientName: '',
        CustomerType: '',
        Product: '',
        PageKind: '',
        pageName: '',
        PageFunction: '',
        PageSubFunction: '',
        previouslyVisited: '',
        Token: '',
        Message: '',
        MessageType: '',
        numberOfAccounts: '',
        ErrorMessage: '',
        RelyingParty: ''
    }
});
const { pageEvents, defaults } = analyticsConfig;
// eslint-disable-next-line sonarjs/cognitive-complexity, max-lines-per-function
const populatePageInfo = (eventOptions) => {
    var _a, _b, _c, _d;
    const _e = eventOptions || {}, { countryLanguage, siteIdentifier, pnl, clientName, customerType, product, pageKind, pageName, pageFunction, pageSubFunction, pathName, previouslyVisited, token, message, messageType, numberOfAccounts, errorMessage, relyingParty } = _e, rest = __rest(_e, ["countryLanguage", "siteIdentifier", "pnl", "clientName", "customerType", "product", "pageKind", "pageName", "pageFunction", "pageSubFunction", "pathName", "previouslyVisited", "token", "message", "messageType", "numberOfAccounts", "errorMessage", "relyingParty"]);
    return Object.assign({ Country_Language: countryLanguage || defaults.Country_Language, SiteIdentifier: siteIdentifier || defaults.SiteIdentifier, Device: defaults.Device, PNL: pnl || defaults.PNL, ClientName: clientName || defaults.ClientName, CustomerType: customerType || defaults.CustomerType, Product: product || defaults.Product, PageKind: pageKind || ((_a = pageEvents[pathName]) === null || _a === void 0 ? void 0 : _a.PAGE_KIND) || defaults.PageKind, pageName: pageName || ((_b = pageEvents[pathName]) === null || _b === void 0 ? void 0 : _b.PAGE_NAME) || defaults.pageName, PageFunction: pageFunction ||
            ((_c = pageEvents[pathName]) === null || _c === void 0 ? void 0 : _c.PAGE_FUNCTION) ||
            defaults.PageFunction, PageSubFunction: pageSubFunction ||
            ((_d = pageEvents[pathName]) === null || _d === void 0 ? void 0 : _d.PAGE_SUB_FUNCTION) ||
            defaults.PageSubFunction, previouslyVisited: previouslyVisited || defaults.previouslyVisited, Token: token || defaults.Token, Message: message || defaults.Message, MessageType: messageType || defaults.MessageType, numberOfAccounts: numberOfAccounts || defaults.numberOfAccounts, ErrorMessage: errorMessage || defaults.ErrorMessage, RelyingParty: relyingParty || defaults.RelyingParty }, rest);
};
// V2 WIP
const deviceV2 = (isBrowser && 'Desktop') ||
    (isMobileOnly && 'Mobile') ||
    (isTablet && 'Tablet') ||
    '';
const formatMetadata = (eventOptions) => {
    if (!eventOptions)
        return [];
    const formattedMetadata = [];
    Object.keys(eventOptions).forEach(key => {
        const value = eventOptions[key];
        if (!value)
            return;
        formattedMetadata.push({ key, value });
    });
    return formattedMetadata;
};
const triggerAnalyticsEvent = (eventOptions, eventOptionsV2, config) => {
    if (typeof window === 'undefined')
        return;
    const params = new URLSearchParams(window.location.search);
    // if this config value is false or missing we will trigger and populate original _SFDDL
    if (!(config === null || config === void 0 ? void 0 : config.shouldPassthroughV1Trigger)) {
        const populatedPageInfo = populatePageInfo(eventOptions);
        window._SFDDL.pageInfo = Object.assign(Object.assign({}, window._SFDDL.pageInfo), populatedPageInfo);
    }
    // don't populate v2 object unless v2 event is explicitly given
    if (eventOptionsV2) {
        const { channel, correlationId, accountId, accountIdType, event } = eventOptionsV2;
        window._SFDDL_V2 = {
            metadata_generic: formatMetadata({
                date_time: new Date().toISOString(),
                device: deviceV2
            }),
            metadata_web: formatMetadata({
                browser: getBrowser().toString()
            }),
            metadata_campaigns: formatMetadata({
                internal_campaign_id: params.get(INTERNAL_CAMPAIGN_ID_PARAM) || '',
                external_campaign_id: params.get(EXTERNAL_CAMPAIGN_ID_PARAM) || ''
            }),
            metadata_digital_servicing: formatMetadata({
                channel,
                correlation_id: correlationId,
                account_id: accountId,
                account_id_type: accountIdType
            }),
            event: formatMetadata(event)
        };
    }
    const event = new CustomEvent('syfPageView');
    window.dispatchEvent(event);
};
export default triggerAnalyticsEvent;
